import styles from "./ActionButtonBarComponent.module.scss"
import {ReactNode} from "react";

export interface ActionButtonBarComponentProps {
    children: ReactNode;
}

export default function ActionButtonBarComponent({children}: ActionButtonBarComponentProps) {
    return <div className={styles.wrapper}>{children}</div>;
}